var _path, _path2, _circle, _g, _path3, _g2, _path4, _use, _use2, _use3, _path5, _use4, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrtools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.255 8.616h341.23v443.6h-341.23z",
    fill: "#e7e8ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 460.74H153.708V.077H512V460.74zm-341.23-17.062h324.17V17.138H170.77v426.54z",
    fill: "#6e6f71"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136.622,
    cy: 375.421,
    r: 127.962,
    fill: "#ffd200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8a0f00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.646 511.923h-.307C60.952 511.838-.085 450.664 0 375.277s61.26-136.424 136.646-136.34h.307c75.386.085 136.424 61.26 136.34 136.646s-61.26 136.425-136.646 136.34zm0-255.923c-65.96-.077-119.5 53.343-119.56 119.294S70.42 494.785 136.38 494.86h.264c65.823-.077 119.2-53.334 119.43-119.158.077-65.926-53.232-119.482-119.158-119.704h-.272zm0 191.942h-.128c-28.22-.068-51.133-19.894-51.082-44.2h17.062c0 14.895 15.244 27.043 34.063 27.094h.085c18.768 0 34.046-12.07 34.123-26.95a12.977 12.977 0 00-10.024-11.406l-53.624-18c-12.455-3.515-21.2-14.7-21.6-27.623a41.05 41.05 0 0115.628-31.675 54.29 54.29 0 0135.659-12.276c28.22.068 51.133 19.894 51.082 44.2h-17.062c0-14.895-15.245-27.043-34.063-27.094h-.128a38.54 38.54 0 00-24.628 8.377 24.283 24.283 0 00-9.46 18.563 12.97 12.97 0 009.998 11.414l53.624 18c12.446 3.515 21.182 14.7 21.6 27.623-.06 24.246-22.972 43.952-51.124 43.952z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38 290.14l-.34 170.616-17.062-.034.34-170.616z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.38 42.74h272.985v59.715H196.38z",
    fill: "#87d0f0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6e6f71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.38 136.578h42.654v42.654H196.38z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 76.777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7 136.578h42.654v42.654H426.7zm0 76.777h42.654v42.654H426.7z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 76.777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.38 213.355h42.654v42.654H196.38z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 76.777,
    y: 76.777
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 76.777,
    y: 153.554
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 153.554
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 76.777,
    y: 230.332
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 230.332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.71 290.132h42.654v119.43H426.71z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.953 238.938h-.307C61.26 238.853.085 299.9.01 375.286c-.085 75.386 60.96 136.56 136.347 136.637h.3c75.386.085 136.56-60.96 136.637-136.347.077-75.378-60.96-136.552-136.34-136.638zm-.307 255.924h-.273c-65.96-.077-119.37-53.607-119.294-119.567S70.686 255.923 136.646 256h.273c65.96.077 119.37 53.607 119.294 119.567s-53.607 119.37-119.567 119.295zm34.19-147.787H187.9c.043-21.788-18.4-39.933-42.56-43.507v-13.462h-17.062v13.42a53.74 53.74 0 00-27.119 11.704 41.05 41.05 0 00-15.628 31.675c.4 12.933 9.136 24.108 21.6 27.623l20.986 7.038-.1 48.344c-13.607-1.595-24.244-12.48-25.533-26.113h-17.06c-.043 21.788 18.4 39.933 42.56 43.507v13.462h17.062v-13.462c24.168-3.472 42.654-21.54 42.748-43.336-.4-12.933-9.145-24.108-21.6-27.623l-21.003-7.038.1-48.344c13.605 1.587 24.26 12.472 25.548 26.113zm-42.653 16.507l-15.628-5.212a12.97 12.97 0 01-9.964-11.423 24.304 24.304 0 019.46-18.563 36.67 36.67 0 0116.208-7.439l-.077 42.637zm32.56 28.9a12.97 12.97 0 019.964 11.414c-1.348 13.632-12.037 24.475-25.652 26l.094-42.654 15.594 5.23zM512 452.208V8.608c0-4.7-3.822-8.53-8.53-8.53H162.24c-4.7 0-8.53 3.822-8.53 8.53v213.27h17.062V17.138h324.17v426.54H281.67v17.062h221.8c4.7 0 8.53-3.822 8.53-8.53zM477.877 42.73c0-4.7-3.822-8.53-8.53-8.53H196.36c-4.7 0-8.53 3.822-8.53 8.53v59.715c0 4.7 3.822 8.53 8.53 8.53h272.985c4.7 0 8.53-3.822 8.53-8.53V42.73zm-17.062 51.184H204.892V51.26h255.923v42.654zm-272.985 85.31c0 4.7 3.822 8.53 8.53 8.53h42.654c4.7 0 8.53-3.822 8.53-8.53V136.57c0-4.7-3.822-8.53-8.53-8.53H196.36c-4.7 0-8.53 3.822-8.53 8.53v42.654zM204.9 145.1h25.592v25.592H204.9V145.1zm119.433-8.53c0-4.7-3.822-8.53-8.53-8.53H273.14c-4.7 0-8.53 3.822-8.53 8.53v42.654c0 4.7 3.822 8.53 8.53 8.53h42.654c4.7 0 8.53-3.822 8.53-8.53V136.57zm-17.06 34.123H281.67V145.1h25.592v25.592z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 76.777
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.83 230.408h17.062v-8.53h25.592v42.654h8.53c4.7 0 8.53-3.822 8.53-8.53v-42.654c0-4.7-3.822-8.53-8.53-8.53H196.36c-4.7 0-8.53 3.822-8.53 8.53V230.4zm136.493-17.062c0-4.7-3.822-8.53-8.53-8.53H273.14c-4.7 0-8.53 3.822-8.53 8.53V256c0 4.7 3.822 8.53 8.53 8.53h42.654c4.7 0 8.53-3.822 8.53-8.53v-42.654zm-17.06 34.123H281.67v-25.592h25.592v25.592z"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    x: -76.777
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.323 290.123c0-4.7-3.822-8.53-8.53-8.53H273.14c-4.7 0-8.53 3.822-8.53 8.53v17.062h17.062v-8.53h25.592v25.592H290.2v17.062h25.592c4.7 0 8.53-3.822 8.53-8.53v-42.654zm76.777 0c0-4.7-3.822-8.53-8.53-8.53h-42.654c-4.7 0-8.53 3.822-8.53 8.53v42.654c0 4.7 3.822 8.53 8.53 8.53h42.654c4.7 0 8.53-3.822 8.53-8.53v-42.654zm-17.062 34.123h-25.592v-25.592h25.592v25.592zM290.2 401.023v17.062h25.592c4.7 0 8.53-3.822 8.53-8.53V366.9c0-4.7-3.822-8.53-8.53-8.53H290.2v17.062h17.062v25.592H290.2zm102.37-42.653h-42.654c-4.7 0-8.53 3.822-8.53 8.53v42.654c0 4.7 3.822 8.53 8.53 8.53h42.654c4.7 0 8.53-3.822 8.53-8.53V366.9c0-4.7-3.822-8.53-8.53-8.53zm-8.53 42.654h-25.592V375.43h25.592v25.592zm85.306-119.432h-42.654c-4.7 0-8.53 3.822-8.53 8.53v119.43c0 4.7 3.822 8.53 8.53 8.53h42.654c4.7 0 8.53-3.822 8.53-8.53v-119.43c0-4.7-3.822-8.53-8.53-8.53zm-8.53 119.43h-25.592v-102.37h25.592v102.37z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M273.155 136.578h42.654v42.654h-42.654z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M401.1 136.57c0-4.71-3.822-8.53-8.53-8.53h-42.654a8.533 8.533 0 00-8.53 8.53v42.654c0 4.71 3.822 8.53 8.53 8.53h42.654c4.71 0 8.53-3.822 8.53-8.53V136.57zm-17.062 34.123h-25.592V145.1h25.592v25.592z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M477.877 213.346c0-4.71-3.822-8.53-8.53-8.53h-42.654a8.533 8.533 0 00-8.53 8.53V256c0 4.71 3.822 8.53 8.53 8.53h42.654c4.71 0 8.53-3.822 8.53-8.53v-42.654zm-17.062 34.123h-25.592v-25.592h25.592v25.592z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrtools);
export default __webpack_public_path__ + "static/media/trtools.c3a2c057344249c0da48d79ea60da44e.svg";
export { ForwardRef as ReactComponent };